import { useSelector } from 'react-redux'

export type EagleDisplayMode = '2D' | '3D'

/**
 * System-wide display mode (2D/3D), sourced from backend appsettings (EagleDisplayMode).
 * Reads from Redux (fetched on bootstrap in Main), falls back to localStorage, defaults to '3D'.
 *
 * Usage: const { displayMode, is2D, is3D } = useDisplayMode()
 */
export function useDisplayMode() {
    const displayMode: EagleDisplayMode = useSelector(
        (state: any) => state?.app?.displayMode
    ) || (localStorage.getItem('eagleDisplayMode') as EagleDisplayMode) || '3D'

    // #8427/SKY-28: is the mode authoritatively known yet? Redux flag first, falls back to a
    // cached localStorage value. Guards use this to avoid redirecting during the is2D flicker.
    const loaded: boolean = useSelector(
        (state: any) => state?.app?.displayModeLoaded
    ) || !!localStorage.getItem('eagleDisplayMode')

    return {
        displayMode,
        is2D: displayMode === '2D',
        is3D: displayMode !== '2D',
        loaded,
    }
}

/** Quick read without the hook (for use outside React components if needed). */
export function getDisplayMode(): EagleDisplayMode {
    return (localStorage.getItem('eagleDisplayMode') as EagleDisplayMode) || '3D'
}
